function getSwatchStyle(colorName) {
  var config = window.LOQSwatchConfig || {};
  var key = colorName.toLowerCase().trim();
  var value = config[key];
  if (!value) return '--swatch-background: linear-gradient(to right, ' + key + ', ' + key + ')';
  if (value.indexOf('url(') === 0) return '--swatch-background: ' + value;
  if (value.indexOf('linear-gradient') !== -1) return '--swatch-background: ' + value;
  return '--swatch-background: linear-gradient(to right, ' + value + ', ' + value + ')';
}

function injectSwatches(cardEl, allMembers, currentUrl) {
  var crossContainer = cardEl.querySelector('.js-cross-swatches');
  if (!crossContainer) return;

  while (crossContainer.firstChild) crossContainer.removeChild(crossContainer.firstChild);

  var nativeFieldset = cardEl.querySelector('.product-card__info fieldset:not(.js-cross-swatches)');
  if (nativeFieldset) nativeFieldset.hidden = true;

  allMembers.forEach(function (m) {
    var a = document.createElement('a');
    a.href = m.url;
    a.className = 'color-swatch' + (m.url === currentUrl ? ' is-selected' : '');
    if (m.colorName) a.setAttribute('data-tooltip', m.colorName);
    a.setAttribute('style', m.swatchStyle);
    a.innerHTML = '<span class="sr-only">' + m.colorName + '</span>';
    crossContainer.appendChild(a);
  });

  crossContainer.hidden = false;
}

function runColourGroups() {
  var cards = document.querySelectorAll('product-card[data-colour-base]');
  if (!cards.length) return;

  var groups = {};

  cards.forEach(function (card) {
    var base = card.dataset.colourBase;
    var productUrl = card.dataset.productUrl;
    var colorName = card.dataset.colourName || '';
    var nativeSwatch = card.querySelector('.product-card__info .color-swatch');
    var swatchStyle = (nativeSwatch && nativeSwatch.getAttribute('style')) || getSwatchStyle(colorName);

    if (!groups[base]) groups[base] = [];
    groups[base].push({ card: card, url: productUrl, colorName: colorName, swatchStyle: swatchStyle });
  });

  Object.keys(groups).forEach(function (base) {
    var members = groups[base];

    if (members.length >= 2) {
      // Multiple cards visible — inject directly
      var allMembers = members.map(function (m) {
        return { url: m.url, colorName: m.colorName, swatchStyle: m.swatchStyle };
      });
      members.forEach(function (m) {
        injectSwatches(m.card, allMembers, m.url);
      });
    } else {
      // Single card — fetch related from in-stock collection
      fetch('/collections/in-stock/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          var allMembers = [];

          products.forEach(function (p) {
            var parts = p.title.split(' in ');
            if (parts.length < 2 || parts[0] !== base) return;
            var colorName = parts[parts.length - 1].trim();
            allMembers.push({
              url: '/products/' + p.handle,
              colorName: colorName,
              swatchStyle: getSwatchStyle(colorName)
            });
          });

          if (allMembers.length < 2) return;

          members.forEach(function (m) {
            injectSwatches(m.card, allMembers, m.url);
          });
        })
        .catch(function () {});
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  runColourGroups();

  var productList = document.querySelector('.product-list');
  if (!productList) return;

  var debounceTimer;
  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (n.tagName === 'PRODUCT-CARD' || n.querySelector('product-card'));
      });
    });
    if (hasNewCards) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(runColourGroups, 400);
    }
  });

  observer.observe(productList, { childList: true, subtree: true });
});
